// Stan firmy w kreatorze rejestracji (ADR-0025 usługi tenantów): komunikat
// i przycisk z API oraz werdykt po powrocie z logowania administratora firmy.

/** Przycisk z API — teksty z `@no-human/tenants-client`, te same we wszystkich produktach. */
export type AkcjaFirmy = { kind: "login"; label: string; href: string } | { kind: "company_login"; label: string };

export interface StanFirmy {
  stan: "nowa" | "w_produkcie" | "realm_bez_produktu";
  message?: string;
  action?: AkcjaFirmy;
  /**
   * Werdykt logowania, które się nie udało (`brak_roli`, `blad`). Kreator
   * pokazuje wtedy ponowne logowanie innym kontem zamiast martwego komunikatu.
   */
  werdykt?: "brak_roli" | "blad";
}

export interface WyborLogowania {
  rodzaj: "realm_firmy" | "klienci";
  label: string;
}

/** Odpowiedź `GET /public/register/company-login/status`. */
export interface StatusLogowaniaFirmy {
  stan: "potwierdzone" | "brak_roli" | "blad" | "brak";
  email?: string;
  rodzaj?: WyborLogowania["rodzaj"];
  message?: string;
}

export type PoPowrocie =
  | { kind: "dowod"; email: string; rodzaj: WyborLogowania["rodzaj"] }
  | { kind: "firma"; firma: StanFirmy }
  | { kind: "nic" };

/**
 * Co kreator pokazuje po powrocie z logowania administratora firmy.
 *
 * Bez roli (albo po błędzie) człowiek nie może zostać w ślepym zaułku: dostaje
 * przycisk ponownego logowania innym kontem. Przycisk to `company_login` — API
 * odpowiada na niego wyborem konta (konto firmy / panel klienta), gdy firma ma
 * oba logowania, albo od razu adresem logowania. Logowanie zawsze pyta o konto
 * (`prompt=login`), więc „innym kontem” jest dosłowne.
 */
export function poPowrocie(r: StatusLogowaniaFirmy, etykietaPonownie: string): PoPowrocie {
  if (r.stan === "potwierdzone" && r.email) return { kind: "dowod", email: r.email, rodzaj: r.rodzaj ?? "realm_firmy" };
  if (r.stan === "brak_roli" || r.stan === "blad") {
    return {
      kind: "firma",
      firma: {
        stan: "realm_bez_produktu",
        werdykt: r.stan,
        ...(r.message ? { message: r.message } : {}),
        action: { kind: "company_login", label: etykietaPonownie },
      },
    };
  }
  return { kind: "nic" };
}
